<template>
  <div>
    <b-row class="bg-dark p-3 rounded">
      <b-col sm="12" class="text-center mb-3">
        <h5>{{ form._id ? 'Edit' : 'Add New'}} Client</h5>
      </b-col>
      <b-form @submit="onSubmit" inline>
        <b-col sm="4" class="pb-2">
          <b-form-input
          id="oNumber"
          v-model="form.oNumber"
          type="text"
          placeholder="org. number"
          class="mr-3"
          :state="oNumValid"
          trim>
          </b-form-input>
        </b-col>

        <b-col sm="4" class="pb-2">
          <b-form-input
          id="name"
          v-model="form.name"
          type="text"
          placeholder="client's name"
          class="mr-3"
          required>
          </b-form-input>
        </b-col>

        <b-col sm="4" class="pb-2">
          <b-form-input
          id="email"
          v-model="form.email"
          type="text"
          placeholder="email"
          class="mr-3"
          required
          trim>
          </b-form-input>
        </b-col>

        <b-col sm="4" class="pb-2">
          <b-form-input
          id="phone"
          v-model="form.phone"
          type="text"
          placeholder="phone"
          class="mr-3"
          :state="phoneValid"
          trim>
          </b-form-input>
        </b-col>

        <b-col sm="4" class="pb-2">
          <b-form-input
          id="address"
          v-model="form.address"
          type="text"
          placeholder="address"
          class="mr-3">
          </b-form-input>
        </b-col>

        <b-col sm="4" class="pb-2">
          <b-form-input
          id="postCode"
          v-model="form.postCode"
          type="text"
          placeholder="post code"
          class="mr-3"
          trim>
          </b-form-input>
        </b-col>

        <b-col sm="4" class="pb-2">
          <b-form-input
          id="city"
          v-model="form.city"
          type="text"
          placeholder="city"
          class="mr-3">
          </b-form-input>
        </b-col>

        <b-col sm="8" class="text-right">
          <b-button block class="mr-5 px-5" style="width:94%" type="submit" variant="primary">SAVE</b-button>
        </b-col>
      </b-form>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';

import fixed from '../../fixed';

const API_URL = `${fixed.API_URL}/admin`;
export default {
  data: () => ({
    form: {
      oNumber: '',
      name: '',
      email: '',
      phone: '',
      address: '',
      postCode: null,
      city: '',
    },
  }),
  mounted() {
    if (this.$route.query._id) this.form = Object.assign(this.form, this.$route.query); // eslint-disable-line
  },
  computed: {
    oNumValid() {
      return this.form?.oNumber.length ? this.form.oNumber.length === 9 : null;
    },
    phoneValid() {
      return this.form?.phone.length ? this.form.phone.length === 8 : null;
    },
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault();
      try {
        this.form.isPrivate = !this.form.oNumber;
        this.form.ttexId = +this.form.ttexId;
        await axios.post(`${API_URL}/clients`, this.form, { withCredentials: true });
        this.$router.push({ name: 'companies' });
      } catch (err) {
        this.$toast.error(err?.response?.statusText || 'error while saving client');
      }
    },
  },
};
</script>

<style>

</style>
